import {
    filterWithoutClosedAccountingPeriods,
    filterWithSelectedAccountingPeriod,
} from "../../services/accountingPeriods";

import moment from "moment-timezone";
import { Component, Vue } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["close", "changeDateRange"],
})
export class ossDateRangePickerBase extends Vue {
    @Prop({ default: "" }) begin: string;
    @Prop({ default: "" }) end: string;
    @Prop({ default: "" }) cyPrefix: string;
    @Prop({ default: false }) hideDetails: boolean;
    @Prop({ default: false }) dense: boolean;
    @Prop({ default: "date" }) type: string;
    @Prop({ default: "" }) label: string;
    @Prop({ default: false }) disabled: boolean;
    @Prop({ default: false }) activate: boolean;
    @Prop({ default: false }) hideActivator: boolean;
    @Prop({ default: false }) filterWithoutClosedAccountingPeriods: boolean;
    @Prop({ default: false }) filterWithSelectedAccountingPeriod: boolean;
    @Prop({ default: "" }) textFieldClass: string;
    @Prop({ default: "day" }) formatDate: string;
    @Prop({ default: "" }) prefixDataCy: string;

    dateDialog_ = false;

    get dateDialog() {
        return this.activate || this.dateDialog_;
    }

    set dateDialog(value) {
        this.dateDialog_ = value;
    }

    get dateRange() {
        const dateRange = [];

        if (!this.currentDateRange) return dateRange;

        const startDate = moment(this.currentDateRange.begin);
        if (!this.currentDateRange.end) return [startDate.toDate()];

        const endDate = moment(this.currentDateRange.end);
        let currentDate = startDate;

        while (currentDate <= endDate) {
            dateRange.push(currentDate.toDate());
            currentDate = currentDate.add(1, "days");
        }

        return dateRange;
    }

    currentDateRange: {
        begin: string;
        end: string;
    } = null;

    set dateRange(dateRange) {
        const data = {
            begin: "",
            end: "",
        };
        switch (dateRange.length) {
            case 0:
                data.begin = "";
                data.end = "";
                break;
            case 1:
                data.begin = dateRange[0];
                data.end = "";
                break;
            default:
                data.begin = dateRange[0];
                data.end = dateRange[dateRange.length - 1];
                break;
        }
        this.currentDateRange = data;
    }

    get fullTextFieldClass() {
        let tfClass = "small-prepend-icon";
        if (this.textFieldClass) {
            tfClass += " " + this.textFieldClass;
        }
        return tfClass;
    }

    get formatDateRange() {
        let formated = "";
        // debugger;
        const format = this.formatDate === "month" ? "MM/YYYY" : "DD/MM/YYYY";

        if (this.begin && this.end) {
            formated = `Du ${moment(this.begin).format(format)} au ${moment(this.end).format(
                format,
            )}`;
        } else if (this.begin && !this.end) {
            formated = `Du ${moment(this.begin).format(format)}`;
        } else if (!this.begin && this.end) {
            formated = `au ${moment(this.end).format(format)}`;
        } else if (this.label !== "" && !this.begin && !this.end) {
            formated = this.label;
        } else {
            formated = "Filtrer par date";
        }
        return formated;
    }

    allowedDates(date) {
        if (this.filterWithSelectedAccountingPeriod) {
            return filterWithSelectedAccountingPeriod(
                this.$store.state.accountingPeriod.selectedAccountingPeriod,
                date,
            );
            return true;
        } else if (this.filterWithoutClosedAccountingPeriods) {
            return filterWithoutClosedAccountingPeriods(
                this.$store.state.accountingPeriod.accountingPeriods,
                date,
            );
        }
        return true;
    }

    close() {
        this.$emit("close");
    }

    valid() {
        this.$emit("changeDateRange", this.currentDateRange);
        this.dateDialog = false;
    }
}
